import React, { useContext } from 'react';
import WeeklyBudgetDataRows from './WeeklyBudgetDataRows';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';

const tableStyle = {
    display: 'flex',
    border: '1px solid #d7d7d7',
    boxSizing: 'border-box',
    height: 35,
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: '#414141',
    fontFamily: 'roboto',
    fontWeight: 500,
    position: 'relative',
    backgroundColor: '#ffffff'
};

const WeeklyBudgetTable = ({
    budgetData = [],
    totalBudget,
    onChange,
    readOnly,
    ...props
}) => {
    const { formatCurrency } = useContext(SystemSettingsContext);

    const headHeight = 30;
    const visibleActiveRows = 5;
    const rowHeight = 30;
    const totalHeight = rowHeight * visibleActiveRows + headHeight;

    const generateGridTemplateAreas = () => {
        // active grid headers
        let retVal = `'weekH dateH amountH gutterH'`;
        // active grid data
        for (let i = 0; i < budgetData.length || i < visibleActiveRows; i++) {
            retVal = `
                ${retVal}
                'week${i} date${i} amount${i} ${
                i < visibleActiveRows ? 'gutter' : '.'
            }'
            `;
        }

        return retVal;
    };

    return (
        <div {...props}>
            <div
                style={{
                    display: 'grid',
                    boxSizing: 'border-box',
                    gridTemplateColumns: '75px 100px 150px 19px',
                    gridTemplateAreas: generateGridTemplateAreas(),
                    backgroundColor: '#ffffff',
                    overflowY: 'hidden',
                    height: totalHeight
                }}
            >
                <WeeklyBudgetDataRows
                    data={budgetData}
                    onChange={onChange}
                    rowHeight={rowHeight}
                    visibleRows={visibleActiveRows}
                    readOnly={readOnly}
                />
            </div>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        ...tableStyle,
                        width: 175,
                        fontSize: 13,
                        borderWidth: '0 1px 1px 1px',
                        justifyContent: 'center'
                    }}
                >
                    <span style={{ fontWeight: 'bold', paddingLeft: 3 }}>
                        {window.translate('Total budget')}
                    </span>
                </div>
                <div
                    style={{
                        ...tableStyle,
                        width: 169,
                        fontSize: 20,
                        borderWidth: '0 1px 1px 0',
                        justifyContent: 'center',
                        alignItems: 'flex-end',
                        paddingBottom: 4.5
                    }}
                >
                    <span style={{ paddingLeft: 8 }}>{formatCurrency(totalBudget) || '£0.00'}</span>
                </div>
            </div>
        </div>
    );
};

export default WeeklyBudgetTable;
